export const COUNT_DOWN = "COUNT_DOWN";
export const COUNT_UP = "COUNT_UP";
export const SET_TIME = "SET_TIME";
export const START_TIMER = "START_TIMER";
export const STOP_TIMER = "STOP_TIMER";
export const DEV_COUNT_UP = "DEV_COUNT_UP";
export const DEV_COUNT_DOWN = "DEV_COUNT_DOWN";
